import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { withRouter } from "../utils/withRouter";
import ProductItemModel from "../models/product-item-model";
import EventBox from "../components/eventBox";
import userEventService from "../services/user-event.service";

interface EventPageState {
    count: number;
    selectedDate?: Date;
    productId?: string;
    productsList?: Array<ProductItemModel>;
}

interface EventPageProps {
    params: {
        id: string;
    };
}

class EventPage extends Component<EventPageProps, EventPageState> {
    constructor(props: EventPageProps) {
        super(props);
        const prodID = this.props.params.id;
        this.state = {
            count: 0,
            selectedDate: new Date(),
            productId: prodID ? prodID : '',
            productsList: []
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'event_page_open', { productId: this.state.productId });
    }

    increment = () => {
        this.setState({ count: this.state.count + 1 });
    }

    render() {
        //<EventBox service={this.state.productId} key={product.id} productData={product}></EventBox>
        return (
            <Container className="oc-products">
                <Row className="oc-page-title">
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <h2>UPCOMING EVENTS</h2>
                    </Col>
                </Row>
                <Row className="oc-page-content">
                    <Col lg={3} md={6} sm={12} xs={12}>
                        <h4>Choose date</h4>
                        <DatePicker 
                            inline 
                            selected={this.state.selectedDate} 
                            onChange={(date) => this.setState({selectedDate: date ? date : new Date()})}>
                        </DatePicker>
                    </Col>
                    <Col lg={9} md={6} sm={12} xs={12}>
                        <h3>csütörtök, 2025.09.16</h3>
                        { this.state.productsList?.map(product => (
                            <></>
                        ))}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(EventPage);